export const EVENT_LOCATIONS = [
  { text: "Recepção", value: "RECEPTION" },
  { text: "Foyer", value: "FOYER" },
  { text: "Foyer 2", value: "FOYER_2" },
  { text: "Plenária 1", value: "AUDITORIUM_1" },
  { text: "Plenária 2", value: "AUDITORIUM_2" },
  { text: "Coquetel", value: "COCKTAIL" },
  { text: "Almoço", value: "LUNCH" },
  { text: "Outros", value: "OTHERS" },
  { text: "Plenária", value: "AUDITORIUM" },
  { text: "Ativação Tecnológica", value: "TECHNOLOGICAL_ACTIVATION" },
  { text: "Ativação Gastronômica", value: "GASTRONOMIC_ACTIVATION" },
  { text: "Sala de Staff", value: "STAFF_ROOM" },
];

export const TRANSLATIONS = [
  { text: "Equipamentos", value: "EQUIPMENT_RENTAL" }, // or EVENT_EQUIPMENT
  { text: "Intérpretes", value: "INTERPRETATION_SERVICES" },
  { text: "Tradutor", value: "TEXT_TRANSLATOR" },
  { text: "Outros", value: "OTHER" },
];

export const TECHNOLOGY = [
  { text: "APP", value: "MOBILE_APPLICATION" },
  { text: "Hotsite", value: "MICROSITE" }, // or LANDING_PAGE
  { text: "Internet", value: "INTERNET_SERVICE" },
  { text: "Outros", value: "OTHER_DIGITAL_SERVICES" },
  { text: "Plataforma Digital", value: "DIGITAL_PLATFORM" },
  { text: "QR Code", value: "QR_CODE_SYSTEM" },
  { text: "Sistema de Credenciamento", value: "ACCREDITATION_SYSTEM" },
];

export const AEB = [
  { text: "Café da manhã", value: "BREAKFAST" },
  { text: "Welcome drink", value: "WELCOME_DRINK" },
  { text: "Bebidas", value: "DRINKS" },
  { text: "Almoço", value: "LUNCH" },
  { text: "Pacote de Bebidas Almoço", value: "BEVERAGE_PACKAGE_LUNCH" },
  { text: "Jantar", value: "DINNER" },
  { text: "Pacote de Bebidas Jantar", value: "BEVERAGE_PACKAGE_DINNER" },
  { text: "Welcome coffee", value: "WELCOME_COFFEE" },
  { text: "Coffee Break Manhã", value: "COFFEE_BREAK_MORNING" },
  { text: "Coffee Break Tarde", value: "COFFEE_BREAK_EVENING" },
  { text: "Camarim", value: "DRESSING_ROOM" },
  { text: "Coquetel", value: "COCKTAIL" },
  { text: "Pacote de Bebidas Coquetel", value: "BEVERAGE_PACKAGE_COCKTAIL" },
  { text: "Happy Hour", value: "HAPPY_HOUR" },
  { text: "Lanche box", value: "SNACK_BOX" },
  { text: "Maquinário e utensilios", value: "EQUIPMENT_AND_UTENSILS" },
  { text: "Operacional", value: "OPERATIONAL" },
  { text: "Outros", value: "OTHERS" },
];

export const PRODUCTION_SUPPORT = [
  { text: "Atendimento e produção", value: "SERVICE_AND_PRODUCTION" },
  { text: "Gerenciamento de projeto", value: "PROJECT_MANAGEMENT" },
  { text: "Outros", value: "OTHER" },
];

export const ATTRACTION = [
  { text: "Artista", value: "ARTIST" },
  { text: "Atração musical", value: "MUSICAL_ACT" },
  { text: "Cerimonialista", value: "MASTER_OF_CEREMONIES" },
  { text: "DJ", value: "DJ" },
  { text: "Palestrante", value: "SPEAKER" },
  { text: "Team building", value: "TEAM_BUILDING" },
];

export const BRINDES_INCENTIVOS_PREMIACOES = [
  { text: "Brindes em geral", value: "PROMOTIONAL_ITEMS" },
  {
    text: "Gift card, vouchers e outros benefícios",
    value: "GIFT_CARDS_AND_VOUCHERS",
  },
  { text: "Troféus e placas", value: "TROPHIES_AND_PLAQUES" },
  { text: "Vestuário personalizado", value: "CUSTOM_APPAREL" },
];

export const CENOGRAPHY_DECORATION = [
  { text: "Ambientação", value: "ENVIRONMENT_DESIGN" },
  { text: "Ativação visual", value: "VISUAL_ACTIVATION" },
  { text: "Custos operacionais/staff", value: "OPERATIONAL_COSTS_AND_STAFF" },
  { text: "Itens cenográficos", value: "SCENOGRAPHIC_ITEMS" },
  { text: "Maquetes", value: "SCALE_MODELS" },
  { text: "Mobiliário", value: "FURNITURE" },
  { text: "Tenda", value: "TENT" },
];

export const COMMUNICATIONS = [
  { text: "3D", value: "THREE_D_MODELING" },
  { text: "Conceito", value: "CONCEPT_DESIGN" },
  { text: "Criação", value: "CREATIVE_DEVELOPMENT" },
  {
    text: "Fluxo - Categoria Comunicação - Tipo de Serviço - Sub Tipo de Serviço - Descrição",
    value: "COMMUNICATION_FLOW_SERVICES",
  },
  { text: "Planejamento", value: "PLANNING" },
];

export const CONTENT = [
  { text: "GC", value: "GRAPHIC_CONTENT" }, // or 'GENERATED_CONTENT' depending on context
  { text: "Teaser", value: "TEASER_VIDEO" },
  { text: "Vídeo", value: "VIDEO_PRODUCTION" },
  { text: "Vinheta", value: "JINGLE_OR_BRAND_STING" }, // context-dependent
];

export const EQUIPMENTS = [
  { text: "Frete", value: "FREIGHT" },
  { text: "Gerador", value: "GENERATOR" },
  { text: "Impressora", value: "PRINTER" },
  { text: "Iluminação", value: "LIGHTING" },
  { text: "Laser Pointer", value: "LASER_POINTER" },
  { text: "Mouse", value: "COMPUTER_MOUSE" },
  { text: "No-Break", value: "UPS" }, // Uninterruptible Power Supply
  { text: "Notebook", value: "LAPTOP" },
  { text: "Operacional", value: "OPERATIONAL" },
  { text: "Painel de Led", value: "LED_PANEL" },
  { text: "Plataforma Elevatória", value: "LIFT_PLATFORM" },
  { text: "Projetor", value: "PROJECTOR" },
  { text: "Praticável", value: "STAGE_PLATFORM" }, // or MODULAR_STAGE
  { text: "Processadora", value: "MEDIA_PROCESSOR" }, // or VIDEO_PROCESSOR
  { text: "Púlpito", value: "PODIUM" },
  { text: "Régua de Energia | Extensão", value: "POWER_STRIP_EXTENSION" },
  { text: "Sonorização", value: "SOUND_SYSTEM" },
  { text: "Switch | Kramer | Chaveadora", value: "VIDEO_SWITCHER" }, // or MATRIX_SWITCHER
  { text: "Teclado", value: "KEYBOARD" },
  { text: "Tela", value: "SCREEN" }, // or PROJECTION_SCREEN
  { text: "Transformador", value: "TRANSFORMER" },
  { text: "TV", value: "TELEVISION" },
  { text: "Votação eletrônica", value: "ELECTRONIC_VOTING" },
];
export const PARKING = [
  { text: "Estacionamento", value: "PARKING" },
  { text: "Outros", value: "OTHER" },
];
export const FOTO_VIDEO = [
  { text: "Cinegrafista", value: "VIDEOGRAPHER" },
  { text: "Fotógrafo", value: "PHOTOGRAPHER" },
];

export const ACCOMMODATIONS = [
  { text: "Apartamento single", value: "SINGLE_ROOM" },
  { text: "Apartamento duplo twin", value: "SINGLE_ROOM_TWIN" },
  { text: "Apartamento duplo", value: "DOUBLE_ROOM" },
  { text: "Apartamento triplo", value: "TRIPLE_ROOM" },
  { text: "Check-in", value: "CHECK_IN" },
  { text: "Check-out", value: "CHECK_OUT" },
  { text: "Early check-in", value: "EARLY_CHECK_IN" },
  { text: "Late check-out", value: "LATE_CHECK_OUT" },
  { text: "Frigobar", value: "MINIBAR" },
  { text: "Taxa alteração de frigobar", value: "MINIBAR_RESTOCKING_FEE" },
  { text: "Maleiro", value: "BELLMAN_SERVICE" }, // or PORTER_SERVICE
  { text: "Outros", value: "OTHER_SERVICES" },
  { text: "Abertura de portas", value: "DOOR_OPENING_SERVICE" },
  { text: "Estacionamento", value: "PARKING" },
  { text: "Internet", value: "INTERNET" },
];

export const SUBSCRIPTION = [
  { text: "Inscrição médico sócio", value: "MEMBER_DOCTOR_REGISTRATION" },
  {
    text: "Inscrição médico não sócio",
    value: "NON_MEMBER_DOCTOR_REGISTRATION",
  },
  { text: "Inscrição residente", value: "RESIDENT_REGISTRATION" },
  { text: "Outros", value: "OTHER" },
];

export const LICENCES_TAXES = [
  { text: "ART/RRT", value: "TECHNICAL_RESPONSIBILITY_TERM" }, // or ART_RRT
  { text: "ECAD", value: "COPYRIGHT_FEE" }, // Brazilian copyright collection
  { text: "Licenças, Alvarás e Documentação", value: "LICENSES_AND_PERMITS" },
  { text: "Ponto de Água", value: "WATER_HOOKUP_FEE" },
  { text: "Taxa de Energia/KVA", value: "ENERGY_FEE_PER_KVA" },
  { text: "Taxa de Fiscalização", value: "INSPECTION_FEE" },
  { text: "Taxa de Limpeza", value: "CLEANING_FEE" },
];

export const SUPPORT = [
  { text: "Administrador(a)", value: "ADMIN" },
  { text: "Coordenador(a)", value: "COORDINATOR" },
  { text: "Despesa de alimentação", value: "FOOD_EXPENSE" },
  { text: "Despesa de transporte", value: "TRANSPORT_EXPENSE" },
  { text: "Diretor Técnico", value: "TECHNICAL_DIRECTOR" },
  { text: "Diretor Artístico", value: "ARTISTIC_DIRECTOR" },
  { text: "Produtor", value: "PRODUCER" },
  { text: "Recepcionista", value: "RECEPTIONIST" },
  { text: "Roteirista", value: "SCREENWRITER" },
];

export const GRAPHIC_MATERIAL = [{ text: "Serviços", value: "SERVICES" }];
export const MOUNTING_COMPANY = [{ text: "Serviços", value: "SERVICES" }];
export const TRAVEL_INSURANCE = [{ text: "Serviços", value: "SERVICES" }];
export const EVENT_INSURANCE = [{ text: "Serviços", value: "SERVICES" }];

export const NECESSARY_ADDITIONS = [
  { text: "99Taxi", value: "TAXI_SERVICE" }, // or NINETYNINE_TAXI for brand specificity
  { text: "Motoboy", value: "MOTORCYCLE_COURIER" },
  { text: "Outros", value: "OTHER_TRANSPORT" },
  { text: "Transportadora", value: "CARGO_TRANSPORT" }, // or FREIGHT_SERVICE
];

export const TRANSFER = [
  { text: "Transfer in", value: "ARRIVAL_TRANSFER" },
  { text: "Transfer out", value: "DEPARTURE_TRANSFER" },
  { text: "Coordenação", value: "AIRPORT_COORDINATION" },
  { text: "Outros", value: "OTHER" },
];

export const SERVICE_SUPPORT = [
  // Health & Emergency
  { text: "Ambulância", value: "AMBULANCE_SERVICE" },
  { text: "Cilindros Ar Medicinal", value: "MEDICAL_OXYGEN_TANKS" },
  { text: "Paramédicos", value: "PARAMEDICS" },

  // Safety Personnel
  { text: "Brigadista", value: "FIRE_SAFETY_TECHNICIAN" },
  { text: "Equipe de Segurança", value: "SECURITY_TEAM" },
  { text: "Segurança do Trabalho", value: "OCCUPATIONAL_SAFETY" },
  { text: "Extintores e EPI", value: "FIRE_EXTINGUISHERS_AND_PPE" },

  // Operational Staff
  { text: "Carregador", value: "PORTER_SERVICE" },
  { text: "Equipe de Limpeza", value: "CLEANING_TEAM" },
  { text: "Maleiro", value: "BELLHOP_SERVICE" },
  { text: "Manuseio", value: "MATERIAL_HANDLING" },
  { text: "Manutencista e Eletricista", value: "MAINTENANCE_AND_ELECTRICIAN" },

  // Event Staff
  { text: "Maquiador", value: "MAKEUP_ARTIST" },
  { text: "Modelo", value: "MODEL" },
  { text: "Recepcionista", value: "RECEPTIONIST" },
  { text: "Recreador", value: "ENTERTAINER" }, // or EVENT_ANIMATOR
];

export const HUMAN_RESOURCES_STAFF = [
  { text: "Carregadores", value: "CHARGERS" },
  { text: "Coordenador EXT", value: "EXTERNAL_COORDINATOR" },
  { text: "Coordenador INT", value: "INTERNAL_COORDINATOR" },
  { text: "Diretor Artístico", value: "ARTISTIC_DIRECTOR" },
  { text: "Diretor Técnico", value: "TECHNICAL_DIRECTOR" },
  { text: "Outros", value: "OTHERS" },
  { text: "Produtor EXT", value: "EXTERNAL_PRODUCER" },
  { text: "Produtor INT", value: "INTERNAL_PRODUCER" },
  { text: "Recepcionista", value: "RECEPCIONIST" },
  { text: "Reembolso de Staff", value: "STAFF_REIMBURSEMENT" },
  { text: "Roteirista", value: "SCRIPTWRITER" },
  { text: "Sonoplasta", value: "SOUND_DESIGNER" }, // or AUDIO_ENGINEER
];

export const RSVP = [
  { text: "Nacional", value: "NATIONAL_RSVP" },
  { text: "Internacional", value: "INTERNATIONAL_RSVP" },
  { text: "Emergencial nacional", value: "NATIONAL_EMERGENCY_RSVP" },
  { text: "Emergencial", value: "EMERGENCY_RSVP" },
  { text: "Anuidade do sistema", value: "ANNUAL_MEMBERSHIP_FEE" },
  { text: "Licença de usuário", value: "USER_LICENSE_FEE" },
  { text: "Outros", value: "OTHER" },
];

export const ROOMS = [
  { text: "Plénaria", value: "PLENARY_ROOM" },
  { text: "Sala", value: "MEETING_ROOM" }, // Note: Corrected typo to "ROOM" in value
  { text: "Espaço para Coffee Break", value: "COFFEE_RECEPTION_SPACE" },
  { text: "Espaço para coquetel", value: "COCKTAIL_RECEPTION_SPACE" },
  { text: "Espaço para festa", value: "PARTY_VENUE" },
  { text: "Espaço privativo", value: "PRIVATE_SPACE" },
  { text: "Estacionamento", value: "PARKING" },
  { text: "Água", value: "WATER" },
  { text: "Garrafa", value: "BOTTLE" },
  { text: "Garrafa de Café", value: "COFFEE_BOTTLE" },
  { text: "Internet", value: "INTERNET" },
  { text: "Outros", value: "OTHER" },
];

export const AIR = [
  { text: "Custo por pessoa", value: "AERIAL_FORECAST_PER_PERSON" },
  { text: "Seguir planilha aérea", value: "AERIAL_WORKSHEET" },
  { text: "Outros", value: "OTHER" },
];

export const SEVERAL = [
  {
    text: "Decoração para festa de encerramento",
    value: "CLOSING_PARTY_DECORATION",
  },
  { text: "DJ para o festa de encerramento", value: "CLOSING_PARTY_DJ" },
  { text: "Ecad para banda/dj", value: "" },
  { text: "Estacionamento", value: "PARKING" },
  { text: "Fotógrafo", value: "PHOTOGRAPHER" },
  {
    text: "Impressão de materiais gráficos",
    value: "GRAPHIC_MATERIAL_PRINTING",
  },
  { text: "Limpeza", value: "CLEANING" },
  { text: "Link dedicado", value: "DEDICATED_LINK" },
  { text: "Lunch box", value: "LUNCH_BOX" },
  { text: "Manobrista", value: "WALLET" },
  { text: "Mobiliário", value: "FURNITURE" },
  { text: "Pesquisa de satisfação", value: "SATISFACTION_SURVEY" },
  { text: "Ponto de internet", value: "ACCESS_POINT" },
  { text: "Ramal telefônico", value: "TELEPHONE_EXTENSION" },
  { text: "Segurança", value: "SECURITY" },
  { text: "Seguro Viagem", value: "TRAVEL_INSURANCE" },
  { text: "Stand", value: "STAND" },
  { text: "Telefônia", value: "TELEPHONY" },
];
interface StringMap {
  [key: string]: any;
}
export const ServiceOptions: StringMap = {
  ACCOMMODATIONS: ACCOMMODATIONS,
  ROOMS: ROOMS,
  AEB: AEB,
  EQUIPMENTS: EQUIPMENTS,
  COMMUNICATIONS: COMMUNICATIONS,
  TRANSLATIONS: TRANSLATIONS,
  SUPPORT: SUPPORT,
  SUBSCRIPTION: SUBSCRIPTION,
  RSVP: RSVP,
  AIR: AIR,
  TRANSFER: TRANSFER,
  SEVERAL: SEVERAL,
  PRODUCTION_SUPPORT: PRODUCTION_SUPPORT,
  ATTRACTION: ATTRACTION,
  BRINDES_INCENTIVOS_PREMIACOES: BRINDES_INCENTIVOS_PREMIACOES,
  CENOGRAPHY_DECORATION: CENOGRAPHY_DECORATION,
  CONTENT: CONTENT,
  PARKING: PARKING,
  FOTO_VIDEO: FOTO_VIDEO,
  LICENCES_TAXES: LICENCES_TAXES,
  GRAPHIC_MATERIAL: GRAPHIC_MATERIAL,
  MOUNTING_COMPANY: MOUNTING_COMPANY,
  NECESSARY_ADDITIONS: NECESSARY_ADDITIONS,
  HUMAN_RESOURCES_STAFF: HUMAN_RESOURCES_STAFF,
  TRAVEL_INSURANCE: TRAVEL_INSURANCE,
  SERVICE_SUPPORT: SERVICE_SUPPORT,
  EVENT_INSURANCE: EVENT_INSURANCE,
  TECHNOLOGY: TECHNOLOGY,
};
